import React from 'react';
import './HeroShip.scss';

const HeroShip = () => <div className='hero-ship' />;

export default HeroShip;
